<template><div class="app-root"><router-view /><password-change-dialog /></div></template>
<script>
import PasswordChangeDialog from './components/PasswordChangeDialog.vue'
export default { name: 'App', components: { PasswordChangeDialog } }
</script>
<style>.app-root{height:100%}.password-required-page{padding:40px;color:#607d8b}</style>
